module.exports = __webpack_public_path__ + "img/feteira_01.5bac9298.jpg";